import { LogBack } from '@/utils/auth'

/**
 *
 * 处理错误状态吗
 * @param {Object} res
 */
export function handleErrors(res, options = {}) {
  const silent = options && options.silent
  if (!silent) {
    console.log('[handleErrors] API 业务错误码:', res.code, '| message:', res.message)
  }
  switch (res.code) {
  case 50012:
  case 50014:
    LogBack('您登录已过期，请重新登录')
    return false
  case 50015:
    LogBack('账号已过期，请重新登录~')
    return false
  case 50016:
    LogBack('登录超时，请重新登录！')
    return false
  case 50013:
    LogBack('账号已过期，请重新登录~')
    return false
  }
  return true
}
